// extracted by mini-css-extract-plugin
export default {"box":"errorPage_box__c274Q","msgBox":"errorPage_msgBox__J8-oh","msgBox__msg":"errorPage_msgBox__msg__cLwX3","btn":"errorPage_btn__ozl7e"};